<div class="reminder-shell">
  <div class="subtab-bar">
    <button
      type="button"
      class="subtab"
      [class.active]="activeSubTab === 'health'"
      (click)="setSubTab('health')">
      Heald recommendations
    </button>
    <button
      type="button"
      class="subtab"
      [class.active]="activeSubTab === 'careTeam'"
      (click)="setSubTab('careTeam')">
      Care team recommendations
    </button>
  </div>

  <!-- Heald recommendations -->
  <div *ngIf="activeSubTab === 'health'" class="subtab-panel">
    <div class="form-row">
      <div class="field">
        <label>Habit Name</label>
        <select class="control" [(ngModel)]="selectedHabitHealthId" (change)="onHabitChangeHealth()" [disabled]="isLoadingReminderCategories">
          <option [ngValue]="null">Choose Habit</option>
          <option *ngFor="let h of habitItems" [ngValue]="h.id">{{ h.name }}</option>
        </select>
      </div>

      <div class="field">
        <label>Category</label>
        <select class="control" [(ngModel)]="selectedHealthNameId" [disabled]="isLoadingReminderCategories || !selectedHabitHealthId">
          <option [ngValue]="null">Choose Category</option>
          <option *ngFor="let c of healthNameOptions" [ngValue]="c.nameId">{{ c.label }}</option>
        </select>
      </div>

      <div class="field">
        <label>Card color</label>
        <select class="control" [(ngModel)]="selectedCardColorHealth" [disabled]="isLoadingReminderCategories || !selectedHabitHealthId">
          <option [ngValue]="null">Choose Color</option>
          <option *ngFor="let color of cardColors" [ngValue]="color">{{ color }}</option>
        </select>
      </div>

      <div class="actions">
        <button
          type="button"
          class="primary"
          (click)="addHealthRecommendation()"
          [disabled]="!selectedHabitHealthId || selectedHealthNameId == null || !selectedCardColorHealth">
          Add as heald recommendations
        </button>
      </div>
    </div>

    <div class="cards-shell">
      <div *ngIf="isLoadingHabitRecommendations" class="cards-muted">Loading recommendations...</div>

      <div *ngIf="!isLoadingHabitRecommendations && healdRecommendationCards.length === 0" class="cards-muted">
        No heald recommendations found.
      </div>

      <div class="cards-grid" *ngIf="!isLoadingHabitRecommendations && healdRecommendationCards.length > 0">
        <div class="rec-card" *ngFor="let r of healdRecommendationCards">
          <div class="rec-row">
            <div class="rec-label">Habit Name</div>
            <div class="rec-value">{{ r.habitName }}</div>
          </div>
          <div class="rec-row">
            <div class="rec-label">Category</div>
            <div class="rec-value">{{ r.categoryName }}</div>
          </div>
          <div class="rec-row">
            <div class="rec-label">Created Date</div>
            <div class="rec-value">{{ r.modifiedDate ? (r.modifiedDate | date: 'MMMM d, y':'UTC') : '-' }}</div>
          </div>
          <div class="rec-row">
            <div class="rec-label">Status</div>
            <div class="rec-value" [class.used]="r.isUsed" [class.not-used]="!r.isUsed">
              {{ r.isUsed ? 'This habit is used' : 'This habit is not used yet' }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Care team recommendations -->
  <div *ngIf="activeSubTab === 'careTeam'" class="subtab-panel">
    <div class="form-row">
      <div class="field">
        <label>Habit Name</label>
        <select class="control" [(ngModel)]="selectedHabitCareTeamId" (change)="onHabitChangeCareTeam()" [disabled]="isLoadingReminderCategories">
          <option [ngValue]="null">Choose Habit</option>
          <option *ngFor="let h of habitItems" [ngValue]="h.id">{{ h.name }}</option>
        </select>
      </div>

      <div class="field">
        <label>Category</label>
        <select class="control" [(ngModel)]="selectedCareTeamNameId" [disabled]="isLoadingReminderCategories || !selectedHabitCareTeamId">
          <option [ngValue]="null">Choose Category</option>
          <option *ngFor="let c of careTeamNameOptions" [ngValue]="c.nameId">{{ c.label }}</option>
        </select>
      </div>

      <div class="field">
        <label>Card color</label>
        <select class="control" [(ngModel)]="selectedCardColorCareTeam" [disabled]="isLoadingReminderCategories || !selectedHabitCareTeamId">
          <option [ngValue]="null">Choose Color</option>
          <option *ngFor="let color of cardColors" [ngValue]="color">{{ color }}</option>
        </select>
      </div>

      <div class="actions">
        <button
          type="button"
          class="primary"
          (click)="addCareTeamRecommendation()"
          [disabled]="!selectedHabitCareTeamId || selectedCareTeamNameId == null || !selectedCardColorCareTeam">
          Add as care team recommendations
        </button>
      </div>
    </div>

    <div class="cards-shell">
      <div *ngIf="isLoadingHabitRecommendations" class="cards-muted">Loading recommendations...</div>

      <div *ngIf="!isLoadingHabitRecommendations && careTeamRecommendationCards.length === 0" class="cards-muted">
        No care team recommendations found.
      </div>

      <div class="cards-grid" *ngIf="!isLoadingHabitRecommendations && careTeamRecommendationCards.length > 0">
        <div class="rec-card" *ngFor="let r of careTeamRecommendationCards">
          <div class="rec-row">
            <div class="rec-label">Habit Name</div>
            <div class="rec-value">{{ r.habitName }}</div>
          </div>
          <div class="rec-row">
            <div class="rec-label">Category</div>
            <div class="rec-value">{{ r.categoryName }}</div>
          </div>
          <div class="rec-row">
            <div class="rec-label">Created Date</div>
            <div class="rec-value">{{ r.modifiedDate ? (r.modifiedDate | date: 'MMMM d, y':'UTC') : '-' }}</div>
          </div>
          <div class="rec-row">
            <div class="rec-label">Status</div>
            <div class="rec-value" [class.used]="r.isUsed" [class.not-used]="!r.isUsed">
              {{ r.isUsed ? 'This habit is used' : 'This habit is not used yet' }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
